<template>
  <div class="mb-3">
    <v-card dark class="elevation-5" style="width: 250px">
      <v-list class="py-0" style="background-color: #000">
        <v-list-tile>
          <v-list-tile-title
            style="text-align: center; font-size: 20px; color: white"
            >Commission</v-list-tile-title
          >
        </v-list-tile>
      </v-list>
      <v-list class="py-0" style="overflow: hidden">
        <v-list-tile v-for="item in items" :key="item.title" :to="item.link">
          <v-list-tile-action> </v-list-tile-action>
          <v-list-tile-content class="white--text">
            {{ item.title }}
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      items: [
        {
          icon: "person",
          title: "Commission Area",
          permission_name: "manager_manage",
          link: "/weserve_admin_login/-/CommissionArea",
          drop: true,
          droptitle: "Commission Area",
        },
      ],
    };
  },
};
</script>
